import config from "@/config.js";
export default {
    methods: {
        goToChat(userId, username) {
            this.$http
                .post(`${config.BASE_URL}api/v2/admin/system-chats`, {
                    user_id: userId
                })
                .then(response => {
                    if (response.body.status) {
                        this.$router.push({
                            name: "chat",
                            params: {
                                chatId: response.body.data._id,
                                user_name:username
                            }
                        });
                    }
                });
        }
    }
}